import vehicleConfiguration from './setVehicleConfiguration';
import accountData from './setAccountData';
import trimData from './setTrimData';
import selectedTrimData from './setSelectedTrimData';
import enableContinueBtn from './setContinueBtn';
import rootDir from './setRootDirectory';

const root = {
	vehicleConfiguration,
	accountData,
	trimData,
	selectedTrimData,
	enableContinueBtn,
	rootDir
};

export default root;
